import List from "@/components/list";
import router from "@/router";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const handleDelete = listeners["handleDelete"] || function () { };
  const setDown = listeners["setDown"] || function () { };


  function handleEdit(data) {
    router.push({
      path: "topicLectureManage/add",
      query: {
        id: data.uuid,
      },
    });
  }
  // 名单管理-管理
  function goUserManageManage(item) {
    router.push({
      path: "topicLectureManage/userManage",
      query: {
        uuid: item.uuid,
        isScanSign: item.isScanSign,
        publishStatus: item.publishStatus
      },
    });
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    dealConf.push(["icon-edit", "编辑", () => handleEdit(vo.row), "topicLectureManage:update"]);
    dealConf.push(["icon-delete", "删除", () => handleDelete(vo.row), "topicLectureManage:delete"]);
    if (vo.row.publishStatus == 0) {
      dealConf.push(["icon_fabu", "发布", () => setDown(vo.row.uuid), "topicLectureManage:publish"])
    }
    dealConf.push(["icon-student", "学员管理", () => goUserManageManage(vo.row), "topicLectureManage:userManage"])
    
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ClassName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span class="ellipsis--l2">{item.className}</span>
    )
  };

  const AccountTableConfig = [
    {
      label: "讲座主题",
      minWidth: "220",
      prop: "lectureName",
      showOverflowTooltip: true,
    },
    {
      label: "讲座类型",
      minWidth: "150",
      prop: "lectureTypeName",
    },
    {
      label: "讲座时间",
      prop: "trainTimeStr",
      minWidth: "160"
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      minWidth: "100",
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "160",
    },
    {
      label: "操作",
      width: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
